<template>
  <div
    class="d-flex-column justify-start align-start gap-20"
    style="margin-top: 12px"
  >
    <h4 class="t-white font-family-1 title-h5 f-w-600">
      {{ $t("calculators_common.platforms_champions") }}
    </h4>
    <div
      class="d-flex-row space-between platform_picker_container md-row-to-col gap-10"
    >
      <DropDown
        :placeholder="$t('calculators_common.select_platform')"
        :drop-items="getKeyedPlatforms"
        :select-drop-item="selectPlatform"
        :selected-item="checkoutStore.getSelectedPlatform"
        img="platform"
      />
      <DropDown
        :placeholder="$t('calculators_common.select_legend')"
        :drop-items="getKeyedLegends"
        :select-drop-item="selectLegend"
        :selected-item="selectedHero"
        img="legend"
      />
    </div>
  </div>
</template>

<script>
import DropDown from "../../../custom/DropDown.vue";
export default {
  data() {
    return {};
  },
  components: {
    DropDown,
  },
  computed: {
    selectedHero() {
      if (this.checkoutStore.getSelectedHeros[0]) {
        return this.checkoutStore.getSelectedHeros[0];
      }
      return null;
    },
    getKeyedPlatforms() {
      return this.getGame?.platforms?.reduce((accumulator, value) => {
        return { ...accumulator, [value.id]: value.title };
      }, {});
    },
    getKeyedLegends() {
      return this.getGameHeroes?.reduce((accumulator, value) => {
        return { ...accumulator, [value.id]: value.title };
      }, {});
    },
  },
  methods: {
    selectPlatform(key, value) {
      this.checkoutStore.setPlatform({
        platform: parseInt(value),
      });
    },
    selectLegend(key, value) {
      this.checkoutStore.setOneHero({
        championId: parseInt(value),
      });
    },
  },
  beforeMount() {},
  setup() {
    const { getGame, getGamePack, getGameHeroes } = useGameStore();
    const checkoutStore = useCheckoutStore();

    return {
      getGame,
      getGamePack,
      getGameHeroes,
      checkoutStore,
    };
  },
};
</script>
